import { render } from "./Article.vue?vue&type=template&id=3f6ea906&scoped=true"
const script = {}

import "./Article.vue?vue&type=style&index=0&id=3f6ea906&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6ea906"]])

export default __exports__